import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LayoutManagerComponent } from './layout-manager.component'
import { NotFoundComponent } from './not-found/not-found.component'

@NgModule({
  imports: [CommonModule],
  declarations: [LayoutManagerComponent, NotFoundComponent],
  exports: [LayoutManagerComponent],
})
export class LayoutManagerModule {}

export { LayoutManagerComponent }
